import React from 'react';
import {HiOutlineArrowSmDown} from "react-icons/hi";

const Scroll = () => {
  return (
    <div className="home__scroll">
        <a href="#about" className="home__scroll-button button--flex">
        <a href="#about" className="scroll-down" style={{marginTop: "10rem"}}>
                        <div class="scrolldown" style={{color: "skyblue"}}>
                                <div class="chevrons">
                                    <div className="chevrondown"></div>
                                    <div className="chevrondown"></div>
                                </div>
                        </div>
                    </a>
        </a>
    </div>
  )
}

export default Scroll;